/* global axios */
import ApiClient from './ApiClient';

class AutomationsAPI extends ApiClient {
  constructor() {
    super('automation_rules', { accountScoped: true });
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  manualTrigger(automationId, conversationId) {
    return axios.post(`${this.url}/${automationId}/manual_trigger`, {
      conversation_id: conversationId,
    });
  }
}

export default new AutomationsAPI();
